/**
 * created by li si yi
 * 发布统计（全部媒体）
 */
import React, {Component} from 'react';
import BaseComponent from "../../../base/BaseComponent";
import {message} from "antd";
import {getInfoFromLocalStorage, setInfoToLocalStorage} from "../../../actions";

class PublishStatistics extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            loadStatus: 'start',
            params: {
                deptIds: window.currentUser.deptIds.toString(),
                // deptIds: "",
                mediaIds: "",
                type: 1,// 1代表近1月，2代表近一年
            },
            changeParams: {
                deptIds: window.currentUser.deptIds.toString(),
                // deptIds: "",
                mediaIds: "",
                type: 1,// 1代表近1月，2代表近一年
            },
            dataSource: [],// echarts列表数据
            dataResources: [],// 最终渲染的数据
            deptList: [],// 部门数据
            mediaList: [],// 媒体数据
            isQuery: true,// 切换单个数据时不刷新原有数据
            currentData: {},// 当前点击
            getCurrentData: [],// 当前数据切换后数据存储
            resetDept: [],// 重置
            resetMedia: [],
            otherParams: {},// 其他参数
            mediaListAll:[],// 所有媒体，用来查找图标
        };
    }

    componentWillMount() {
        let key = this.props.match.params.configName ? this.props.match.params.configName : '';
        this.getConfig(key);
        this.getMediaList();
    }

    componentDidMount() {
        // this.getDept().then(() => {
        //     let deptId = [window.currentUser.deptIds.toString()];
        //     this.getMedia(deptId, () => {
        //         this.onQueryCall();
        //     });
        // });
        setTimeout(()=>{
            this.getDept();
            let deptId = [window.currentUser.deptIds.toString()];
            this.getMedia(deptId, () => {
                this.onQueryCall();
            });
        },0)
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (this.props.match.params.configName !== nextProps.match.params.configName) {
            let key = nextProps.match.params.configName ? nextProps.match.params.configName : '';
            this.getConfig(key);
            this.getDept();
            let deptId = [window.currentUser.deptIds.toString()];
            this.getMedia(deptId, () => {
                this.onQueryCall();
            });
        }
    }

    config = [];
    getConfig = (key) => {
        this.key = key;
        if (!key || (typeof key !== "string")) return console.log("字段不合法");
        let config = null;
        try {
            config = require(`./config/${key}`)?.config;
        } catch (e) {
            console.log(e.toString())
        }
        this.config = config;
        console.log("==========this.config===================", this.config)
    };

    renderSearch = (config) => {
        let children = [];
        for (let i = 0; i < config?.searchConfig.length; i++) {
            let itemData = config?.searchConfig[i];
            if (!itemData) {
                return
            }
            children.push(
                <div key={i}>
                    {this.renderItemControl(itemData[i].component[0])}
                </div>
            );
        }
        return children;
    };
    renderList = (config) => {
        let children = [];
        for (let i = 0; i < config?.listConfig.length; i++) {
            let itemData = config?.listConfig[i];
            if (!itemData) {
                return
            }
            children.push(
                <div key={itemData[i].key} style={{flex: 1}}>
                    {this.renderItemControl(itemData[i].component[0])}
                </div>
            );
        }
        return children;
    };
    /**
     * 渲染固定字段（前端配置）
     * 固定字段位置不固定
     * 在需要的位置取这里的字段进行定向渲染
     * */
    componentList = {};
    renderItemControl = (component) => {
        let Component = null;
        if (!component.componentType || (typeof component.componentType !== "string")) return console.log("字段不合法");
        try {
            Component = require(`./component/${component.componentType}`).default;
        } catch (e) {
            console.log(e.toString())
        }
        // 其他参数
        if (component?.otherParams) {
            this.state.otherParams = component?.otherParams || {};
        }
        return (
            Component ?
                <Component
                    ref={ref => this.componentList[component.componentType] = ref}
                    key={component.componentType}
                    // onChange={onChange}
                    otherParams={component?.otherParams}// 其他参数是否显示部门等
                    deptList={this.state.deptList}// 获取部门列表
                    // mediaList={this.state.mediaList}// 获取媒体列表
                    onExport={this.export}// 导出
                    chartsData={this.state.dataResources ? this.state.dataResources : []}// echarts数据
                    checkDept={(res) => {
                        console.log("==========", res);
                        this.state.params.deptIds = res.join(",");
                        this.getMedia(res);
                        this.setState({})
                    }}
                    checkMedia={(res) => {
                        // console.log(res)
                        // console.log(this.state.params.deptIds)
                        if (res && res.length > 0) {
                            this.state.params.mediaIds = res.join(",");
                            // this.setState({})
                        } else {
                            let deptValue = this.state.params.deptIds.split(',');
                            this.getMedia(deptValue)
                        }
                    }}
                    type={this.state.params.type}// 选中类型
                    onQueryCall={this.onQueryCall}// 查询
                    onRefreshCall={this.onRefreshCall}// 重置
                    onChartsCall={({type, currentData}) => {
                        this.state.isQuery = false;
                        this.state.currentData = currentData;
                        this.state.changeParams.type = type;
                        this.state.changeParams.mediaIds = currentData?.mediaId;
                        this.state.changeParams.deptIds = this.state.params.deptIds || window.currentUser.deptIds.toString()
                        // 还要传部门、媒体，再调接口
                        this.getList();
                    }}
                    resetDept={this.state.resetDept}
                    resetMedia={this.state.resetMedia}
                    loadStatus={this.state.loadStatus}
                />
                : null
        )
    };

    // 导出
    export = (item, type) => {
        // console.log("导出接口", item, type);
        let params = {
            mediaId: item.mediaId,
            type: item.exportType ? item.exportType : 1,
        };
        this.request({
            url: "/cm-sites-storage-statistics/manuscript/export/mediaPublish",
            method: 'downloadPost',
            body: params,
        })
    };
    // 统计数据
    getList = () => {
        let params;
        // 查询全部及单个查询年月时传参
        if (this.state.isQuery) {
            params = this.state.params;
        } else {
            params = this.state.changeParams;
        }
        // console.log(params)
        // console.log(this.state?.otherParams?.authorDeptId)
        // 本部门传参
        if (this.state.otherParams.authorDeptId) {
            params = {
                ...params,
                authorDeptId: [window.currentUser.deptIds.toString()]
            };
            delete params.deptIds
        }
        this.setState({loadStatus:'start'})
        this.request({
            url: "/cm-sites-storage-statistics/manuscript/mediaPublish/v2",
            method: 'post',
            contentType: 'json',
            body: params,
            callBack: (res) => {
                let dataSource = [];
                if (res) {
                    dataSource = res;
                    // 查找图标
                    this.state.mediaListAll.forEach((Item, Index) => {
                        if (Item.mediaList) {
                            Item.mediaList.forEach((item, index) => {
                                dataSource.forEach((i, index) => {
                                    if (i.menuCode == item.id) {
                                        dataSource[index].mediaLogo = item.mediaLogo ? item.mediaLogo : Item.logoUrl ? Item.logoUrl : '';
                                    }
                                })
                            })
                        }
                    });
                }
                if (this.state.isQuery) {
                    // 默认选中一个月
                    dataSource.forEach(item => {
                        item.monthSelect = true
                    });
                    this.setState({dataSource, dataResources: dataSource,loadStatus: 'end'})
                } else {
                    this.setState({getCurrentData: dataSource}, () => {
                        this.state.dataResources.forEach((item, index) => {
                            if (item.mediaId === this.state.currentData.mediaId) {
                                this.state.dataResources[index] = {...this.state.currentData, ...this.state.getCurrentData[0]};
                            }
                        });
                        this.setState({loadStatus: 'end'})
                    })
                }
            }
        })
    };
    // 媒体图标
    getMediaList = () => {
        let currentMediaList = getInfoFromLocalStorage('currentMediaList') || [];
        if (currentMediaList && currentMediaList.length < 1) {
            this.getCurrentMediaList().then((res) => {
                let mediaListAll = [];
                if (res && res.length) {
                    mediaListAll = res
                }
                setInfoToLocalStorage("currentMediaList", mediaListAll);
                this.setState({
                    mediaListAll: mediaListAll
                });
            });
        } else {
            this.setState({mediaListAll: currentMediaList})
        }
    };
    // 获取当前人媒体列表
    getCurrentMediaList = () => {
        return new Promise(((resolve, reject) => {
            this.request({
                url: "/cm-sites-pms/media/getCurrentUserMediaGroupByType",
                callBack: (res) => {
                    resolve(res)
                }
            })
        }))
    };


    //获取全部所属单位
    getDept = () => {
        this.request({
            url: "/cm-sites-storage-statistics/middle/getAll",
            method: 'get',
            // contentType: 'json',
            body: {},
            callBack: (res) => {
                let deptList = [];
                if (res) {
                    deptList = res;
                }
                this.setState({deptList}, () => {
                    // resolve(res);
                })
            }
        })
    };
    //根据单位获取媒体
    getMedia = (value, call) => {
        // console.log(value);
        this.request({
            url: "/cm-sites-pms/media/getMediaByDeptIds",
            method: 'post',
            contentType: 'json',
            body: value,
            callBack: (res) => {
                let mediaList = [];
                let medias = [];// 第一次渲染所有媒体数据
                if (res) {
                    mediaList = res;
                    mediaList.forEach(item => {
                        medias.push(item.id)
                    });
                }
                let mediaIds = medias.join(",");
                this.state.params.mediaIds = mediaIds || "";
                // 判断当前用户默认部门和默认选中的一样时 不需要传mediaIds
                // console.log(value.length === 1, value[0] === window.currentUser.defaultInfo.dept.id, this.state.otherParams.authorDeptId);
                if (Array.isArray(value) && value.length === 1 && value[0] === window.currentUser.defaultInfo.dept.id && this.state.otherParams.authorDeptId === 'authorDeptId') {
                    this.state.params.deptId = [window.currentUser.deptIds.toString()];
                    delete this.state.params.mediaIds
                }
                if (typeof this.componentList?.Screen?.getMediaList === "function") {
                    this.componentList.Screen.getMediaList(mediaList);
                }
                call && call(mediaIds);
            }
        })
    };
    // 查询
    onQueryCall = () => {
        this.state.isQuery = true;
        message.destroy();
        if (!this.state.params?.deptIds) {
            message.error("请选择部门");
            return false
        }
        this.setState({}, () => {
            this.getList();
        })
    };
    // 重置
    onRefreshCall = () => {
        this.state.isQuery = true;
        let deptId = [window.currentUser.deptIds.toString()];
        this.state.params.deptIds = window.currentUser.deptIds.toString();
        this.state.resetDept = deptId;
        this.state.resetMedia = [];
        this.getMedia(deptId, (mediaIds) => {
            this.state.params.mediaIds = mediaIds;
            if (this.state.otherParams.authorDeptId) {
                delete this.state.params.mediaIds
            }
            this.getList();
        });
    };

    render() {
        return (
            <div style={{
                background: '#fff',
                maxHeight: 'calc(100vh - 100px)',
                // height: "calc(100vh - 100px)",
                borderRadius: '5px',
                margin: '15px',
                padding: '29px 32px',
                display: 'flex',
                flexDirection: 'column',
            }} key={this.key}>
                {this.renderSearch(this.config?.page?.[0]?.renderSearch)}
                {this.renderList(this.config?.page?.[0]?.renderList)}
            </div>
        );
    }
}

export default PublishStatistics;
